module.exports = __webpack_public_path__ + "img/imge6.60eda911.png";